import Button from '@components/Button/Button';
import Flex from '@components/Flex/Flex';
import { styled, useTheme } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

export const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'isSelected' && prop !== 'readonly',
})<{ isSelected: boolean; readonly: boolean }>(
  ({ theme, isSelected, readonly }) => ({
    backgroundColor: isSelected
      ? theme.palette.primary[200]
      : theme.palette.common.white,
    border: `1px solid ${theme.palette.grey[500]}`,
    color: theme.palette.black.A100,
    justifyContent: 'flex-start',
    gap: theme.spacing(8),
    padding: theme.spacing(8, 12),
    '.MuiButton-endIcon': {
      display: 'flex',
      flex: '1 0 auto',
    },
    pointerEvents: !readonly ? 'auto' : 'none',
  })
);

export const IconCompleted = () => {
  const theme = useTheme();

  return (
    <Flex
      alignSelf='flex-end'
      borderRadius='100%'
      sx={{ backgroundColor: theme.palette.primary.main }}
    >
      <CheckIcon fontSize='medium' sx={{ color: theme.palette.common.white }} />
    </Flex>
  );
};
